import styled from 'styled-components'
// views
import { Paper } from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/components/DetailsForm/components/view'
import { ReduxSwitchWrapper } from 'components/FormElements/ReduxForm/ReduxSwitch/views'

export const Form = styled(Paper)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const FieldsContainer = styled.div`
  gap: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  ${ReduxSwitchWrapper} {
    grid-column: span 2;
  }
`

export const ResultDurationContainer = styled.div`
  display: grid;
  grid-column-gap: 16px;
  grid-template-columns: 1fr 1fr;

  > span {
    grid-column: span 2;
  }
`

export const ButtonsContainer = styled.div`
  gap: 16px;
  display: flex;
  margin-top: 12px;
`

export const EachPeriodEndsTypeContainer = styled.div`
  grid-column: span 2;
`
